/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const textAnimation = () => {
		const targets = document.querySelectorAll('.js-textAnim');
		targets.forEach(target => target.classList.add('is-animSet'));

		// テキスト分割処理を実行
		targets.forEach(targetElement => {
			let globalIndex = 0; // 全文字を通してカウントするインデックス

			// 直接の子要素のみを取得（childrenを使用）
			const children = Array.from(targetElement.children);
			
			children.forEach(child => {
				// br要素はスキップ（globalIndexをインクリメントしない）
				if (child.tagName === 'BR') {
					return;
				}
				
				// span要素の場合
				if (child.tagName === 'SPAN') {
					// js-textWrapクラスを持つ場合は内部構造を保持したままchar-animを付与
					if (child.classList.contains('js-textWrap')) {
						child.classList.add('char-anim');
						child.style.setProperty('--char-index', globalIndex);
						globalIndex++;
					} else {
						// 通常のspan要素は文字ごとに分割
						const text = child.textContent;
						child.textContent = ''; // 元のテキストを空にする

						text.split('').forEach((char) => {
							const charSpan = document.createElement('span');
							charSpan.textContent = char;
							charSpan.classList.add('char-anim'); // アニメーション用のクラス

							// 通し番号（globalIndex）をカスタムプロパティに設定
							charSpan.style.setProperty('--char-index', globalIndex); 
							child.appendChild(charSpan);
							globalIndex++; // 実際の文字のみインデックスをインクリメント
						});
					}
				}
			});
		});

		// Intersection Observer
		const options = {
			root: null,
			rootMargin: '0px',
			threshold: 0.1
		};

		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const targetElement = entry.target;
					targetElement.classList.add('is-animation');
					// 監視を解除
					observer.unobserve(targetElement);
				}
			});
		}, options);

		// 全ての対象要素に対して監視を開始
		targets.forEach(target => {
			observer.observe(target);
		});
	};

	const textRowAnimation = () => {
		const slideUpRowTexts = document.querySelectorAll('.js-textRowAnim');
		if (slideUpRowTexts.length === 0) return;
		slideUpRowTexts.forEach(slideUpRowText => slideUpRowText.classList.add('is-animSet'));

		// スライドアップアニメーション関数
		const textSlideUpAutoAnime = (target) => {
			// 行ごとにアニメーション
			const texts = target.querySelectorAll('.js-textRowAnim_text');
			
			if (texts.length === 0) return;

			// textsを配列に変換し、各行のアニメーションPromiseを取得
			const animations = [...texts].map((text, index) => {
				// Web Animations APIでスライドアップアニメーション
				return text.animate(
					{
						transform: ['translateY(' + text.dataset.initialTranslate + 'px)', 'translateY(0)'],
					},
					{
						fill: 'forwards',
						duration: 1000,
						easing: 'ease',
						delay: index * 200
					}
				).finished;
			});

			// アニメーション終了後に元のテキストに戻す
			Promise.all(animations).then(() => {
				const baseText = target.querySelector('.js-textRowAnim_base');
				if (baseText) {
					// 元のシンプルなHTMLに戻す
					target.innerHTML = baseText.innerHTML;
				}
				// アニメーション完了フラグを立てる
				target.isFinished = true;
			});
		}

		// アニメーション用マークアップを設定する関数
		const setUpText = (slideUpRowText, baseText) => {
			// 表示領域確保用の透明テキストと、スクリーンリーダー用テキスト
			let html = '<span class="js-textRowAnim_base" aria-hidden="true">' + baseText + '</span><span class="textRowAnim-hidden">' + baseText + '</span>';
			const textHeight = slideUpRowText.clientHeight;
			const styles = getComputedStyle(slideUpRowText);
			let lineHeight = styles.lineHeight;

			// 1行の高さを取得
			if (lineHeight === 'normal') {
				const checker = document.createElement('span');
				checker.className = 'js-textRowAnim_checker';
				checker.setAttribute('aria-hidden', 'true');
				checker.textContent = '　'; // 全角スペースで計測
				slideUpRowText.appendChild(checker);
				lineHeight = checker.clientHeight;
				slideUpRowText.removeChild(checker);
			} else {
				lineHeight = parseFloat(lineHeight);
			}

			// 現在何行なのか調べる（端数切り上げで最後の行も含める）
			const row = Math.ceil(textHeight / lineHeight);

			// アニメーション用 初期位置設定
			// アニメーションが終了していたら位置変更しない
			let translateY = slideUpRowText.isFinished ? 0 : lineHeight;

			// 行ごとにclip-pathを設定するHTMLを生成
			for (let i = 0; i < row; i++) {
				const insetTop = lineHeight * i;
				let insetBottom = textHeight - (lineHeight * (i + 1));
				if (insetBottom < 0) {
					insetBottom = 0;
				}
				html += '<span class="js-textRowAnim_line" aria-hidden="true" style="clip-path: inset(' + insetTop + 'px 0 ' + insetBottom + 'px)"><span class="js-textRowAnim_text" data-initial-translate="' + translateY + '" style="clip-path: inset(' + insetTop + 'px 0 ' + insetBottom + 'px);transform: translateY(' + translateY + 'px)">' + baseText + '</span></span>';
			}

			// 中身をリセットしてHTMLを反映
			slideUpRowText.textContent = '';
			slideUpRowText.insertAdjacentHTML('beforeend', html);
			slideUpRowText.classList.add('is-animation');
		};

		const textObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				const target = entry.target;
				// 要素が画面内に入った場合
				if (entry.isIntersecting) {
					// 少し遅延させてアニメーション発火
					setTimeout(() => {
						textSlideUpAutoAnime(target);
					}, 100);
					// 一度実行したら監視を解除（アニメーションは一回限り）
					textObserver.unobserve(target);
				}
			});
		}, {
			rootMargin: '-10% 0px',
			threshold: 0.8
		});

		slideUpRowTexts.forEach(slideUpRowText => {
			// ベーステキストを保持
			const baseText = slideUpRowText.innerHTML;
			// 初回はアニメーション未完了
			slideUpRowText.isFinished = false;
			// アニメーション用マークアップ設定
			setUpText(slideUpRowText, baseText);
			// Observer監視開始
			textObserver.observe(slideUpRowText);

			const resizeObserver = new ResizeObserver(() => {
				// アニメーション用マークアップ再定義
				setUpText(slideUpRowText, baseText);
				// アニメーションが完了していなければ、監視を継続させる
				if (!slideUpRowText.isFinished) {
					// 一度解除して再監視することで、リサイズ後の正しい状態をObserverに伝える
					textObserver.unobserve(slideUpRowText);
					textObserver.observe(slideUpRowText);
				}
			});
			// リサイズ監視開始
			resizeObserver.observe(slideUpRowText);
		});
	}

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const wellbeingFUNCTIONS = () => {
		textAnimation();
		textRowAnimation();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { wellbeingFUNCTIONS(); }) : wellbeingFUNCTIONS();

})(window.FUNCTIONS);
